var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cfdi-online-benefits" }, [
    _c(
      "div",
      { staticClass: "columns is-multiline is-flex-mobile" },
      _vm._l(_vm.benefits, function(benefit) {
        return _c(
          "div",
          { key: benefit.icon, staticClass: "column is-3 is-6-mobile is-flex" },
          [
            _c("BIcon", {
              staticClass: "benefit-icon",
              attrs: { icon: benefit.icon }
            }),
            _c(
              "div",
              { staticClass: "title is-5 has-text-white has-text-centered" },
              [_vm._v("\n        " + _vm._s(benefit.title) + "\n      ")]
            ),
            _c(
              "div",
              { staticClass: "title is-6 has-text-white has-text-centered" },
              [_vm._v("\n        " + _vm._s(benefit.subtitle) + "\n      ")]
            )
          ],
          1
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }